var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.3125C0 0.964403 0.131696 0.630564 0.366116 0.384422C0.600537 0.138281 0.918479 0 1.25 0H3.94125C4.23713 0.000143022 4.52337 0.110487 4.74906 0.311403C4.97474 0.512319 5.12523 0.79078 5.17375 1.09725L6.09875 6.91819C6.14295 7.19541 6.10122 7.48021 5.9797 7.73066C5.85819 7.98112 5.66331 8.184 5.42375 8.30944L3.48875 9.324C4.18263 11.1295 5.21604 12.7697 6.52722 14.1464C7.8384 15.5232 9.40044 16.6082 11.12 17.3368L12.0875 15.3051C12.2069 15.0538 12.3999 14.8493 12.6382 14.7217C12.8765 14.5942 13.1474 14.5502 13.4113 14.5963L18.955 15.5676C19.2469 15.6185 19.5121 15.7765 19.7034 16.0135C19.8948 16.2505 19.9999 16.551 20 16.8617V19.6875C20 20.0356 19.8683 20.3694 19.6339 20.6156C19.3995 20.8617 19.0815 21 18.75 21H16.25C7.275 21 0 13.3612 0 3.9375V1.3125Z",
    fill: "#66BDDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelIcon);
export default __webpack_public_path__ + "static/media/tel-icon.8e348c2da799f696869ddcdb021152bc.svg";
export { ForwardRef as ReactComponent };